/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { lazy } from "react";

import {
  guardedReload,
  isChunkLoadError,
  isNewVersionDeployed,
  markUpdateError,
  reloadToRetryChunk,
  reportChunkFailure,
} from "./new-version";

export const loadWithRetry = async (componentImport: () => Promise<any>) => {
  try {
    const component = await componentImport();
    if (component?.default) {
      return component;
    }
    const named = Object.values(component).find(
      (value) => typeof value === "function",
    );
    return { default: named };
  } catch (error) {
    if (isChunkLoadError(error)) {
      // true: a deploy removed the chunk. false: the server answered with the
      // version this tab already runs, so the request just failed. Browsers remember
      // a failed module until the page reloads, so a reload is the only retry there
      // is, in both cases. undefined: out of reach, where a reload would lose the page.
      const newVersion = await isNewVersionDeployed();
      if (!newVersion) {
        reportChunkFailure(error);
      }
      const reloading = newVersion
        ? await guardedReload()
        : newVersion === false && (await reloadToRetryChunk());
      // Keep showing the loading state while it reloads. If it can't, this reaches
      // the ErrorBoundary.
      if (reloading) {
        return new Promise<never>(() => undefined);
      }
      if (newVersion) {
        markUpdateError(error);
      }
    }
    throw error;
  }
};

export const lazyWithRetry = (componentImport: () => Promise<any>) =>
  lazy(() => loadWithRetry(componentImport));
